import { useState } from "react";
import NavContext from "./navContext";

const NavState = (props) => {
    const [nav, setNav] = useState([]);

    return (
        <NavContext.Provider value={{nav, setNav}}>
            {props.children}
        </NavContext.Provider>
    );
};
export default NavState;
